<template>
  <div>
    <vsmallheader></vsmallheader>
    <div>
      <div class="listTop">
        <div style="font-size: 14px; color: #888; display: flex; align-items: center">
          <img
            src="@/assets/resource/adresst.png"
            style="width: 15px; height: 15px; margin-right: 5px"
          />
          当前位置：
        </div>
        <span @click="retrun" style="cursor: pointer;font-size: 14px;">微警校/微课专题列表</span>
      </div>
      <div class="listBox">
        <div
          class="boxOne"
          v-for="(item,index) in dissData"
          :key="index"
          @click="gotoDisstations(item.id)"
        >
          <div class="boxoneImg">
            <img :src="item.imgUrl" alt @click="gotoDisstations(item.id)" />
          </div>
          <div>
            <div style="font-size:16px;">{{item.name}}</div>
            <div class="icon" style="margin-top:10px;">
              <div style="color:#666">{{item.source}}</div>
            </div>
          </div>
          <div class="txtName">{{item.des}}</div>
        </div>
        <div class="pageblock">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="total,prev, pager, next,jumper"
            :page-size="listQuerys.limit"
            :current-page.sync="listQuerys.page"
            :total="dataCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import vsmallheader from '@/views/smallHeader/index';
import * as diss from '@/api/studyClass/disstation.js';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vsmallheader,
    linecom,
  },
  data() {
    return {
      dissData: '',
      listQuerys: {
        // 查询字典条件
        page: 1,
        limit: 8, //审核通过的显示在前端页面
        status: 1,
      },
      dataCount: 0,
    };
  },
  created() {
    this.getdissList();
  },
  methods: {
    getdissList() {
      diss.MoocSpecialLoad(this.listQuerys).then((res) => {
        this.dissData = res.data;
        this.dataCount = res.count;
      });
    },
    retrun() {
      this.$router.go(-1);
    },
    gotoDisstations(id) {
      this.$router.push({
        path: '/mooc/disstations',
        query: {
          id: id,
        },
      });
    },
    handleSizeChange(val) {
      this.listQuerys.limit = val;
      this.getdissList();
    },
    handleCurrentChange(val) {
      this.listQuerys.page = val;
      this.getdissList();
    },
  },
};
</script>
<style scoped>
.listTop {
  width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 18px;
  display: flex;
}
.listBox {
  width: 1240px;
  min-height: 700px;
  background-color: #fff;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 97%);
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 10px;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  border-radius: 5px;
}
.boxOne {
  width: 300px;
  height: 400px;
  border: 1px solid #f2f2f2;
  margin-top: 20px;
  margin-left: 8px;
  border-radius: 5px;
  font-size: 14px;
}
.boxOne:hover {
  transform: scale(1.01);
  cursor: pointer;
  box-shadow: 1px 1px 5px rgb(156, 154, 154, 0.996);
}
.boxOne > div:nth-child(1) {
  /* padding-top: 10px; */
  text-align: center;
  height: 170px;
  width: 300px;
}
.boxOne > div:nth-child(1) > img {
  width: 300px;
  height: 170px;
  text-align: center;
  border-radius: 5px;
}

.boxOne > div:nth-child(2) {
  padding: 6px;
  height: 55px;
}
.boxOne > div:nth-child(3) {
  text-indent: 2em;
  padding: 6px;
  height: 134px;
  line-height: 24px;

  color: #666;
}
.icon {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
}
.iconright {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.iconright > div {
  margin-right: 40px;
}
.iconright > img {
  margin-right: 5px;
  width: 25px;
  height: 25px;
}
.pageblock {
  width: 1240px;

  margin-top: 40px;
  text-align: center;
}
.txtName {
  overflow: hidden; /*内容超出后隐藏*/
  text-overflow: ellipsis; /*超出内容显示为省略号*/
  display: -webkit-box; /*将对象作为弹性伸缩盒子模型显示*/
  -webkit-box-orient: vertical; /*从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）*/
  -webkit-line-clamp: 5; /*这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。可根据需要设置超出多少行后显示省略号*/
}
</style>